<template>
<div>
    <Tables ref="tableGrid"
                :columns="['CLIENTE', 'EMPREENDIMENTO', 'VENCIMENTO ATUAL', 'ALTERAÇÃO', 'DT. DA SOLICITAÇÃO', 'STATUS', '']"
                :showSearch="false"
                :showPrint="false"
                style="font-family:'Segoe UI'"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
                >
                <tr v-for="data in dataParcela" v-bind:key="data.id">
                    <TableColumn :IsText="true"   v-on:Edit="click(data)" :status="1" :value="data.cliente.nome"  />
                    <TableColumn :IsText="true"   v-on:Edit="click(data)"  :status="1" :value="data.empreendimento.nome"  />
                    <TableColumn :IsText="true"   v-on:Edit="click(data)"  :status="1" :value="data.vencimentoAtual" />
                    <TableColumn :IsText="true"   v-on:Edit="click(data)" :status="1" :value="data.vencimentoNovo"/>
                    <TableColumn :IsText="true"   v-on:Edit="click(data)" :status="1" :value="data.dataSolicitacaoFormatada" />
                    <TableColumn :newState="true" :newStatusNumber="data.status" :colorStatus="['#30A75F','#DB3939',    '#F6B535'][data.status]" :descriptionNewStatus="['Aprovada','Reprovada', 'Pendente'][data.status]" />
                    <TableColumn :IsActionsButtons="true" v-on:Delete ="$emit('deleteRequest', data.id)" :status="1" :HasChange = "false"/>
                </tr>
    </Tables>

 <b-modal centered hide-footer id="modal-approve" ref="modal-approve">
            <template #modal-header>
                    <p class="title-modal">Deseja aprovar a alteração da data de vencimento?</p>
            </template>
            <approvedisapprove v-on:loadTableAprovar="approveRequest"  v-on:loadTableReprovar="reproveRequest" :selectedParcela="selectedParcela"></approvedisapprove>
</b-modal>
 </div>

</template>

<script>
import tablechangedate from './tablechangedate'
export default tablechangedate
</script>

<style scoped >
.element.style{
    font-size: 20px;
}
.title-modal{
    font-weight: 700;
    color: white;
    font-size: 16px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/changedateofinstallment/components/tablechangedate/tablechangedate.vue